import api from '@/services/api';

const TOKEN_KEY = 'aprocon_token';

function loadSession() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp * 1000 < Date.now()) {
      localStorage.removeItem(TOKEN_KEY);
      return null;
    }
    return { id: String(payload.id), name: payload.name, email: payload.email };
  } catch {
    localStorage.removeItem(TOKEN_KEY);
    return null;
  }
}

export default {
  namespaced: true,

  state: () => ({
    user: loadSession(),
  }),

  getters: {
    isLoggedIn: (state) => !!state.user,
    currentUser: (state) => state.user,
  },

  mutations: {
    SET_USER(state, payload) {
      if (payload && payload.user) {
        state.user = payload.user;
        localStorage.setItem(TOKEN_KEY, payload.token);
      } else {
        state.user = null;
        localStorage.removeItem(TOKEN_KEY);
      }
    },
  },

  actions: {
    async register({ commit, dispatch }, { name, email, password }) {
      const { data } = await api.post('/auth/register', { name, email, password });
      commit('SET_USER', data);
      await Promise.all([
        dispatch('timetracking/init', null, { root: true }),
        dispatch('projects/init', null, { root: true }),
      ]);
      return data.user;
    },

    async login({ commit, dispatch }, { email, password }) {
      const { data } = await api.post('/auth/login', { email, password });
      commit('SET_USER', data);
      await Promise.all([
        dispatch('timetracking/init', null, { root: true }),
        dispatch('projects/init', null, { root: true }),
      ]);
      return data.user;
    },

    async updateProfile({ commit }, { name }) {
      const { data } = await api.put('/auth/profile', { name });
      commit('SET_USER', data);
    },

    async changePassword(_, { currentPassword, newPassword }) {
      await api.put('/auth/password', { currentPassword, newPassword });
    },

    logout({ commit, dispatch }) {
      dispatch('timetracking/reset', null, { root: true });
      dispatch('projects/reset', null, { root: true });
      commit('SET_USER', null);
    },
  },
};
